export { default as Img200 } from './processed/200/Baptiste_1.jpg';
export { default as Img400 } from './processed/400/Baptiste_1.jpg';
export { default as Imgthumb } from './processed/thumb/Baptiste_1.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Baptiste_1.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Baptiste_1.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      211,
      34,
      36
    ],
    "_population": 5074,
    "_hsl": [
      0.9981167608286253,
      0.7224489795918367,
      0.48039215686274506
    ]
  },
  "LightVibrant": {
    "_rgb": [
      236,
      140,
      148
    ],
    "_population": 1,
    "_hsl": [
      0.9861111111111112,
      0.7164179104477613,
      0.7372549019607844
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      124,
      35,
      35
    ],
    "_population": 4428,
    "_hsl": [
      0,
      0.559748427672956,
      0.31176470588235294
    ]
  },
  "Muted": {
    "_rgb": [
      165,
      81,
      81
    ],
    "_population": 26,
    "_hsl": [
      0,
      0.34146341463414637,
      0.4823529411764706
    ]
  },
  "LightMuted": {
    "_rgb": [
      171,
      118,
      119
    ],
    "_population": 61,
    "_hsl": [
      0.9968553459119497,
      0.23981900452488675,
      0.5666666666666667
    ]
  },
  "DarkMuted": {
    "_rgb": [
      72,
      40,
      44
    ],
    "_population": 2,
    "_hsl": [
      0.9791666666666666,
      0.2857142857142857,
      0.2196078431372549
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Baptiste_1.js